/* import __COLOCATED_TEMPLATE__ from './enable-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();